import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', mdp: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setErr('');
    try {
      await login(form.email, form.mdp);
    } catch {
      setErr('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>🏗️</div>
        <h1 style={styles.title}>Les Jardins de la Palmeraie</h1>
        <p style={styles.sub}>Gestion de chantier — Connexion</p>
        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" value={form.email}
            onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
            placeholder="votre@email.ma" required />
          <label style={styles.label}>Mot de passe</label>
          <input style={styles.input} type="password" value={form.mdp}
            onChange={e => setForm(f => ({ ...f, mdp: e.target.value }))}
            placeholder="••••••••" required />
          {err && <p style={styles.err}>{err}</p>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f4f3ee' },
  card: { background:'#fff',borderRadius:16,padding:'2.5rem 2rem',width:'100%',maxWidth:400,boxShadow:'0 4px 24px rgba(0,0,0,.08)' },
  logo: { fontSize:40,textAlign:'center',marginBottom:8 },
  title: { textAlign:'center',fontSize:18,fontWeight:600,marginBottom:4 },
  sub: { textAlign:'center',color:'#6b6b67',fontSize:13,marginBottom:24 },
  label: { display:'block',fontSize:12,fontWeight:600,color:'#444',marginBottom:4,marginTop:14 },
  input: { width:'100%',padding:'10px 12px',border:'1px solid #d0cfca',borderRadius:8,fontSize:14,outline:'none',boxSizing:'border-box' },
  err: { color:'#dc2626',fontSize:13,margin:'10px 0 0' },
  btn: { width:'100%',marginTop:20,padding:'11px',background:'#1a1a18',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer' },
};
